export const APKIcon = () => {
  return (
    <svg
      height="20px"
      width="20px"
      version="1.1"
      id="x32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          d="M335.413,62.069l32.308-47.853c2.808-4.158,1.702-9.856-2.455-12.664c-4.158-2.807-9.856-1.701-12.664,2.456
                        L319.235,53.43C299.968,44.637,278.554,39.737,256,39.737c-22.553,0-43.967,4.9-63.234,13.694L159.398,4.008
                        c-2.807-4.157-8.506-5.263-12.663-2.456c-4.158,2.808-5.263,8.505-2.456,12.664l32.308,47.853
                        c-40.562,24.799-68.666,67.984-72.608,117.976h304.044C404.08,130.053,375.975,86.87,335.413,62.069z M193.951,133.99
                        c-11.754,0-21.283-9.528-21.283-21.283c0-11.755,9.529-21.283,21.283-21.283c11.754,0,21.283,9.528,21.283,21.283
                        C215.234,124.462,205.705,133.99,193.951,133.99z M318.05,133.99c-11.754,0-21.283-9.528-21.283-21.283
                        c0-11.755,9.529-21.283,21.283-21.283c11.754,0,21.283,9.528,21.283,21.283C339.333,124.462,329.804,133.99,318.05,133.99z"
          fill="currentColor"
        ></path>
        <path
          d="M101.653,244.206v175.82c0,13.804,11.28,25.084,25.084,25.084h41.472v41.046
                        c0,14.198,11.615,25.844,25.844,25.844c14.198,0,25.844-11.645,25.844-25.844V445.11h72.971v41.046
                        c0,14.198,11.615,25.844,25.844,25.844c14.199,0,25.844-11.645,25.844-25.844V445.11h36.059c13.774,0,25.084-11.28,25.084-25.084
                        v-175.82v-37.245H101.653V244.206z"
          fill="currentColor"
        ></path>
        <path
          d="M46.75,206.961c-16.426,0-29.864,13.438-29.864,29.864V335.2c0,16.425,13.439,29.864,29.864,29.864
                        c16.425,0,29.864-13.439,29.864-29.864v-98.375C76.614,220.4,63.175,206.961,46.75,206.961z"
          fill="currentColor"
        ></path>
        <path
          d="M465.251,206.961c-16.425,0-29.864,13.438-29.864,29.864V335.2c0,16.425,13.439,29.864,29.864,29.864
                        c16.425,0,29.864-13.439,29.864-29.864v-98.375C495.114,220.4,481.675,206.961,465.251,206.961z"
          fill="currentColor"
        ></path>
      </g>
    </svg>
  );
};
export const Copy = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_340_3437)">
        <path
          d="M3.75 11.25H3C2.60218 11.25 2.22064 11.092 1.93934 10.8107C1.65804 10.5294 1.5 10.1478 1.5 9.75V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H9.75C10.1478 1.5 10.5294 1.65804 10.8107 1.93934C11.092 2.22064 11.25 2.60218 11.25 3V3.75M8.25 6.75H15C15.8284 6.75 16.5 7.42157 16.5 8.25V15C16.5 15.8284 15.8284 16.5 15 16.5H8.25C7.42157 16.5 6.75 15.8284 6.75 15V8.25C6.75 7.42157 7.42157 6.75 8.25 6.75Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_340_3437">
          <rect width="18" height="18" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Plus = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...props}
    >
      <path
        d="M14 9.3335V18.6668M9.33337 14.0002H18.6667M25.6667 14.0002C25.6667 20.4435 20.4434 25.6668 14 25.6668C7.55672 25.6668 2.33337 20.4435 2.33337 14.0002C2.33337 7.55684 7.55672 2.3335 14 2.3335C20.4434 2.3335 25.6667 7.55684 25.6667 14.0002Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Transfer = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className="w-6 h-6"
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M7 10h14l-4 -4"></path>
      <path d="M17 14h-14l4 4"></path>
    </svg>
  );
};
export const Calender = ({ ...props }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0 w-5 h-5 text-text_color_primary1"
      {...props}
    >
      <path
        d="M7.17236 4.79175C6.8307 4.79175 6.54736 4.50841 6.54736 4.16675V1.66675C6.54736 1.32508 6.8307 1.04175 7.17236 1.04175C7.51403 1.04175 7.79736 1.32508 7.79736 1.66675V4.16675C7.79736 4.50841 7.51403 4.79175 7.17236 4.79175Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.8394 4.79175C13.4977 4.79175 13.2144 4.50841 13.2144 4.16675V1.66675C13.2144 1.32508 13.4977 1.04175 13.8394 1.04175C14.181 1.04175 14.4644 1.32508 14.4644 1.66675V4.16675C14.4644 4.50841 14.181 4.79175 13.8394 4.79175Z"
        fill="currentColor"
      ></path>
      <path
        d="M7.58919 12.0834C7.48086 12.0834 7.37253 12.0584 7.27253 12.0168C7.16419 11.9751 7.08086 11.9168 6.99753 11.8418C6.84753 11.6834 6.75586 11.4751 6.75586 11.2501C6.75586 11.1418 6.78086 11.0334 6.82253 10.9334C6.86419 10.8334 6.92253 10.7418 6.99753 10.6584C7.08086 10.5834 7.16419 10.5251 7.27253 10.4834C7.57253 10.3584 7.94753 10.4251 8.18086 10.6584C8.33086 10.8168 8.42253 11.0334 8.42253 11.2501C8.42253 11.3001 8.41419 11.3584 8.40586 11.4168C8.39753 11.4668 8.38086 11.5168 8.35586 11.5668C8.33919 11.6168 8.31419 11.6668 8.28086 11.7168C8.25586 11.7584 8.21419 11.8001 8.18086 11.8418C8.02253 11.9918 7.80586 12.0834 7.58919 12.0834Z"
        fill="currentColor"
      ></path>
      <path
        d="M10.5057 12.0832C10.3974 12.0832 10.289 12.0582 10.189 12.0166C10.0807 11.9749 9.99736 11.9166 9.91403 11.8416C9.76403 11.6832 9.67236 11.4749 9.67236 11.2499C9.67236 11.1416 9.69736 11.0332 9.73903 10.9332C9.7807 10.8332 9.83903 10.7416 9.91403 10.6582C9.99736 10.5832 10.0807 10.5249 10.189 10.4832C10.489 10.3499 10.864 10.4249 11.0974 10.6582C11.2474 10.8166 11.339 11.0332 11.339 11.2499C11.339 11.2999 11.3307 11.3582 11.3224 11.4166C11.314 11.4666 11.2974 11.5166 11.2724 11.5666C11.2557 11.6166 11.2307 11.6666 11.1974 11.7166C11.1724 11.7582 11.1307 11.7999 11.0974 11.8416C10.939 11.9916 10.7224 12.0832 10.5057 12.0832Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.4227 12.0832C13.3144 12.0832 13.206 12.0582 13.106 12.0166C12.9977 11.9749 12.9144 11.9166 12.831 11.8416C12.7977 11.7999 12.7644 11.7582 12.731 11.7166C12.6977 11.6666 12.6727 11.6166 12.656 11.5666C12.631 11.5166 12.6144 11.4666 12.606 11.4166C12.5977 11.3582 12.5894 11.2999 12.5894 11.2499C12.5894 11.0332 12.681 10.8166 12.831 10.6582C12.9144 10.5832 12.9977 10.5249 13.106 10.4832C13.4144 10.3499 13.781 10.4249 14.0144 10.6582C14.1644 10.8166 14.256 11.0332 14.256 11.2499C14.256 11.2999 14.2477 11.3582 14.2394 11.4166C14.231 11.4666 14.2144 11.5166 14.1894 11.5666C14.1727 11.6166 14.1477 11.6666 14.1144 11.7166C14.0894 11.7582 14.0477 11.7999 14.0144 11.8416C13.856 11.9916 13.6394 12.0832 13.4227 12.0832Z"
        fill="currentColor"
      ></path>
      <path
        d="M7.58919 14.9999C7.48086 14.9999 7.37253 14.975 7.27253 14.9333C7.17253 14.8917 7.08086 14.8332 6.99753 14.7582C6.84753 14.5999 6.75586 14.3833 6.75586 14.1666C6.75586 14.0583 6.78086 13.9499 6.82253 13.8499C6.86419 13.7416 6.92253 13.65 6.99753 13.575C7.30586 13.2667 7.87253 13.2667 8.18086 13.575C8.33086 13.7333 8.42253 13.9499 8.42253 14.1666C8.42253 14.3833 8.33086 14.5999 8.18086 14.7582C8.02253 14.9082 7.80586 14.9999 7.58919 14.9999Z"
        fill="currentColor"
      ></path>
      <path
        d="M10.5057 14.9999C10.289 14.9999 10.0724 14.9082 9.91403 14.7582C9.76403 14.5999 9.67236 14.3833 9.67236 14.1666C9.67236 14.0583 9.69736 13.9499 9.73903 13.8499C9.7807 13.7416 9.83903 13.65 9.91403 13.575C10.2224 13.2667 10.789 13.2667 11.0974 13.575C11.1724 13.65 11.2307 13.7416 11.2724 13.8499C11.314 13.9499 11.339 14.0583 11.339 14.1666C11.339 14.3833 11.2474 14.5999 11.0974 14.7582C10.939 14.9082 10.7224 14.9999 10.5057 14.9999Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.4227 14.9999C13.206 14.9999 12.9894 14.9083 12.831 14.7583C12.756 14.6833 12.6977 14.5916 12.656 14.4833C12.6144 14.3833 12.5894 14.2749 12.5894 14.1666C12.5894 14.0583 12.6144 13.9499 12.656 13.8499C12.6977 13.7416 12.756 13.6499 12.831 13.5749C13.0227 13.3833 13.3144 13.2916 13.581 13.3499C13.6394 13.3583 13.6894 13.3749 13.7394 13.3999C13.7894 13.4166 13.8394 13.4416 13.8894 13.4749C13.931 13.4999 13.9727 13.5416 14.0144 13.5749C14.1644 13.7333 14.256 13.9499 14.256 14.1666C14.256 14.3833 14.1644 14.5999 14.0144 14.7583C13.856 14.9083 13.6394 14.9999 13.4227 14.9999Z"
        fill="currentColor"
      ></path>
      <path
        d="M17.589 8.19995H3.42236C3.0807 8.19995 2.79736 7.91662 2.79736 7.57495C2.79736 7.23328 3.0807 6.94995 3.42236 6.94995H17.589C17.9307 6.94995 18.214 7.23328 18.214 7.57495C18.214 7.91662 17.9307 8.19995 17.589 8.19995Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.8392 18.9584H7.17253C4.13086 18.9584 2.38086 17.2084 2.38086 14.1667V7.08342C2.38086 4.04175 4.13086 2.29175 7.17253 2.29175H13.8392C16.8809 2.29175 18.6309 4.04175 18.6309 7.08342V14.1667C18.6309 17.2084 16.8809 18.9584 13.8392 18.9584ZM7.17253 3.54175C4.78919 3.54175 3.63086 4.70008 3.63086 7.08342V14.1667C3.63086 16.5501 4.78919 17.7084 7.17253 17.7084H13.8392C16.2225 17.7084 17.3809 16.5501 17.3809 14.1667V7.08342C17.3809 4.70008 16.2225 3.54175 13.8392 3.54175H7.17253Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
export const Search = ({ ...props }) => {
  return (
    <svg
      fill="currentColor"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z"></path>
    </svg>
  );
};

export const WhatsApp = ({ ...props }) => {
  return (
    <svg
      fill="#ffffff"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#ffffff"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <title>whatsapp</title>
        <path d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z"></path>{" "}
      </g>
    </svg>
  );
};
